<template>
  <div class="" v-if="broker != null">
    <div class="text-base text-center">
      Do you have your profile image?
    </div>

    <div class="mt-1 text-sm text-gray-700 text-center">
      Along with your logo, you can also add your profile image<br/>
      to further increase trust &amp; credibility for your clients.
    </div>

    <div class="mt-1 text-sm text-gray-500 text-center">
      And of course, you can change this later at any time.
    </div>

    <div class="text-center mt-10 cursor-pointer">
      <label for="input-upload-profile-image" class="block">
        <template v-if="loading">
          <img src="/static/img/ajax-loader.gif" 
            class="inline p-6 border-2 border-gray-300 hover:border-gray-400 rounded-lg" />
        </template>

        <template v-else>
          <template v-if="broker.profile_image != null">
            <img :src="broker.profile_image.url" 
              class="inline p-3 border-2 border-gray-300 hover:border-gray-400 rounded-lg w-24" />
          </template>

          <template v-else>
            <img src="https://img.icons8.com/wired/64/000000/user.png"
              class="inline p-3 border-2 border-gray-300 hover:border-gray-400 rounded-lg" />
          </template>


        </template>

        <br/><br/>

        <span class="uppercase font-semibold text-blue-500 border-b-2 border-blue-500 pb-1 hover:text-blue-700 text-xs">
          Select my profile image
        </span>

        <br/><br/>

        <a href="#" class="text-xs text-gray-400 uppercase hover:text-gray-500 hover:underline" 
          v-if="broker.profile_image != null"
          @click.prevent="deleteFile()">Delete</a>
      </label>

      <input 
        class="hidden"
        id="input-upload-profile-image" 
        ref="profile-image"
        type="file" v-on:change="uploadFile($event)" />
    </div>

    <div class="text-center mt-20 flex items-center justify-center">
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-gray-400 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-gray-400 w-3 h-3 rounded-full"></div>
    </div>

    <div class="mt-4 text-xs">
      <table class="w-full">
        <tr>
          <td class="w-1/3">
            <router-link 
              :to="{
                name  : 'broker-onboard-personalize-one',
                params: {
                  brokerId   : $route.params.brokerId
                }
              }"
              tag="a" 
              class="rounded px-4 py-2 text-xs bg-gray-500 hover:bg-gray-600 text-white float-left">
              <svg width="16" height="16" stroke-width="2" class="float-left" style="margin-top:1px;" stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#chevron-left"/>
              </svg>
              Back
            </router-link>
          </td>
          <td class="w-1/3">
            <div class="text-gray-600 text-center">Step 2 of 4</div>
          </td>
          <td class="w-1/3">
            <button
              @click.prevent="next()"
              :class="{ 
                'rounded px-4 py-2 text-xs float-right'    : true,
                'bg-blue-500 hover:bg-blue-600 text-white' : broker.profile_image != null,
                'bg-gray-500 hover:bg-gray-600 text-white' : broker.profile_image == null
              }">

              <span class="float-left">Next</span>

              <svg width="16" height="16" stroke-width="2" class="float-left" style="margin-top:1px;" stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#chevron-right"/>
              </svg>
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import axios          from 'axios'
  import { EventBus }   from '@/shared/event-bus'
  import PageHeader     from '@/shared/components/headers/PageHeader'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  
  export default {

    components: {
      PageHeader,
      SubmitButton2
    },

    data () {
      return {
        loading: false,
        broker : null,
      }
    },

    created() {
      this.getBroker({
        brokerId: this.$route.params.brokerId
      }, (broker) => {
        this.broker = broker
      })
    },

    methods : {
      uploadFile($event) {
        let file     = $event.target.files[0] || $event.dataTransfer.files[0]
        let formData = new FormData()
        formData.append('file', file)
        formData.append('fileType', 'profile_image')
        formData.append('brokerId', this.broker.id)
        this.loading = true

        axios.post(process.env.VUE_APP_API_URL + '/api/broker/upload', formData, {
          headers: {
            'Content-Type'  : 'multipart/form-data',
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          this.loading = false
          this.broker.profile_image = response.data
        }).catch(function(err) {
          this.hideLoader()
        });
      },

      deleteFile() {
        this.broker.profile_image = null
        this.apiDelete({
          brokerId: this.broker.id,
          type    : 'profile_image'
        }, 'broker/delete-upload', () => {
          
        })
      },

      next() {
        if(this.broker.profile_image != null) {
          this.$router.push({
            name  : 'broker-onboard-personalize-three',
            params: {
              brokerId : this.broker.id
            }
          })
        }

        else {
          this.$modal.show('confirm-modal', {
            // width : 600,
            title  : "Are you sure?",
            message: "Are you sure you want to proceed without uploading a profile image?",
            buttons:[{
              label          : 'Yes',
              color          : 'green',
              loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
              action         : () => {
                this.$modal.hide('confirm-modal')
                this.$router.push({
                  name  : 'broker-onboard-personalize-three',
                  params: {
                    brokerId : this.broker.id
                  }
                })
              }
            }, {
              label : 'No',
              color : 'gray',
              action: () => {
                this.$modal.hide('confirm-modal')
              }
            }]
          })
        }
      }
    },
  }
</script>